import NewUsersTable from './NewUsersTable';

export default NewUsersTable;
